// src/components/ui/OrangeLoadingSpinner.jsx
import PropTypes from 'prop-types'
import { cn } from '../../utils/cn'

const OrangeLoadingSpinner = ({ 
  size = 'md', 
  className = '', 
  text = '',
  showText = true
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6', 
    lg: 'h-8 w-8',
    xl: 'h-12 w-12'
  }

  const textSizes = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl'
  }

  return (
    <div className={cn("flex flex-col items-center justify-center", className)}>
      <div 
        className={cn(
          "animate-spin rounded-full border-2 border-orange-200 border-t-orange-500",
          sizeClasses[size],
          text && showText && "mb-2"
        )}
      />
      {text && showText && (
        <p className={cn(
          "text-gray-600 font-medium",
          textSizes[size]
        )}>
          {text}
        </p>
      )}
    </div>
  )
}

OrangeLoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  className: PropTypes.string,
  text: PropTypes.string,
  showText: PropTypes.bool
}

export default OrangeLoadingSpinner
